module.exports = __webpack_public_path__ + "img/pk.41cde439.svg";